import {
	ifAuthenticated,
	ifNotAuthenticated,
	ifAuthenticatedOnline,
	AppTabs,
	Edit,
	Create,
	Index
} from '@/router/index'

import Product from '@/components/product/Product'

export const products = [
	{
		path: '/products',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/products/',
					text: 'Trattamenti'
				},
				{
					to: '/products/productcategories',
					text: 'Categorie'
				}
			]
		},
		children: [
			{
				path: '/products/',
				beforeEnter: ifAuthenticatedOnline,
				component: Index,
				props: {
					modelDef: 'products',
					'action-icon': 'local_offer',
					title: 'Trattamenti'
				}
			},
			{
				path: '/products/productcategories',
				beforeEnter: ifAuthenticatedOnline,
				component: Index,
				props: {
					modelDef: 'productcategories',
					'action-icon': 'local_offer',
					title: 'Categorie'
				}
			}
		]
	},
	{
		path: '/products/create',
		name: 'products-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: route => ({
			modelDef: 'products',
			redirect: route.params.redirect
		})
	},
	{
		path: '/products/:id/edit',
		name: 'products-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: route => ({
			modelDef: 'products',
			id: parseInt(route.params.id),
			redirect: { modelDef: 'products', id: parseInt(route.params.id) }
		})
	},
	{
		path: '/products/:id',
		name: 'products',
		beforeEnter: ifAuthenticatedOnline,
		component: Product,
		props: route => ({
			id: parseInt(route.params.id)
		})
	},
	{
		path: '/products/productcategories/create',
		name: 'productcategories-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: route => ({
			modelDef: 'productcategories',
			redirect: { back: -1 }
		})
	},
	{
		path: '/products/productcategories/:id',
		name: 'productcategories',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: route => ({
			modelDef: 'productcategories',
			id: parseInt(route.params.id),
			redirect: { back: -1 }
		})
	},
	{
		path: '/products/productcategories/:id/edit/',
		name: 'productcategories-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: route => ({
			modelDef: 'productcategories',
			id: parseInt(route.params.id),
			redirect: { back: -1 }
		})
	}
]
